export default __webpack_public_path__ + "static/media/CHANNEL_CONNECT_ONE_TO_ONE_EMEA.3289f6ba.png";